import React, { useState, useEffect } from 'react';
import {
    List, Datagrid, TextField, FunctionField, SimpleList
} from 'react-admin';
import {
    useMediaQuery, makeStyles, IconButton, FormControl, Select, MenuItem, InputLabel
} from '@material-ui/core';
import { customTheme } from "./customTheme";
import CustomSearch from './components/CustomSearch';
import { useLocation } from 'react-router-dom';
import CustomPagination from './components/CustomPagination';
import moment from 'moment';
import CustomFilter from './components/CustomFilter';
import ScrollableTable from './components/ScrollableTable';
import UseAnalyticsEvent from './utils/useAnalyticsEvent';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CustomDateTimePicker from "./components/CustomDateTimePickerV2";
import ParkingSearchSelector from './components/ParkingSearchSelector';


const useStyles = makeStyles({
    list: {
        marginBottom: 0,
    },
    parkingSelectorContainer: {
        display: "grid",
        justifyContent: "space-between",
    },
});

const CATEGORY = "DASHBOARD LOGS SECTION"

const ACTIONS = {
    "CREATE": "#18cc69",
    "UPDATE": "#334d6e",
    "DELETE": "#de575e"
}

export const DashboardLogs = props => {
    const eventTracker = UseAnalyticsEvent();
    const classes = useStyles();
    const location = useLocation();

    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const [displayModal, setDisplayModal] = useState(false);
    const [updatedData, setUpdatedData] = useState("")
    let prevSearch = sessionStorage.getItem(location.pathname) ? JSON.parse(sessionStorage.getItem(location.pathname)) : ""
    const [search, setSearch] = useState(prevSearch.inputSearch)
    let searchTypeState = ["Username", "New Values", "Old Values"]
    const [searchTypes, setSearchTypes] = useState(prevSearch.type ? prevSearch.type : "Username");
    const [filterListValue, setFilterListValue] = useState(prevSearch.radioValue ? prevSearch.radioValue : null)
    const [showFilter] = useState(sessionStorage.getItem("show_filter") === "1");
    let filterTypesInitState = [
        {
            filterType: "Action",
            dataList: [{ name: "CREATE", id: 1 }, { name: "UPDATE", id: 2 }, { name: "DELETE", id: 3 }, { name: "REPLACE", id: 4 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
        {
            filterType: "Section",
            dataList: [{ name: "PARKINGS", id: 1 }, { name: "DASHBOARD USERS", id: 2 }, { name: "CONTROLLERS", id: 3 }, { name: "OPERATOR DEVICES", id: 4 }, { name: "PARKING TERMINAL", id: 5 }],
            listType: "Static",
            caseType: "Static",
            showFilter: true
        },
    ]

    let start_time = moment().utcOffset('+05:30').set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate();
    let end_time = moment().utcOffset('+05:30').set({ hour: 23, minute: 59, second: 59, millisecond: 0 }).toDate();
    const [startDateTime, setStartDateTime] = useState(start_time);
    const [endDateTime, setEndDateTime] = useState(end_time);
    const [startDateTimeFilter, setStartDateTimeFilter] = useState(start_time);
    const [endDateTimeFilter, setEndDateTimeFilter] = useState(end_time);

    const [settingFilterFormat, setSettingFilterFormat] = useState({})

    const [currentParking, setCurrentParking] = useState(prevSearch.currentParking ? prevSearch.currentParking : {});

    const filter = { ...settingFilterFormat, search: { value: search ? search : "", type: searchTypes ? searchTypes : "" }, start_time: startDateTimeFilter ? moment(startDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : startDateTime ? moment(startDateTime).format("YYYY-MM-DD HH:mm:ss")  :  "", end_time: endDateTimeFilter ? moment(endDateTimeFilter).format("YYYY-MM-DD HH:mm:ss") : endDateTime ? moment(endDateTime).format("YYYY-MM-DD HH:mm:ss") : "", access_key: currentParking.id, parking_info_id: currentParking.allZones ? currentParking.parking_info_id : undefined };

    const zoneIds = currentParking.zone_ids ? currentParking.zone_ids.split(",") : null;
    const zoneLabels = currentParking.zones ? currentParking.zones.split(";") : null;
    const finalZones = zoneIds && zoneLabels ? zoneIds.map((id, index) => (
        { id, name: zoneLabels[index] }
    )) : null;
    if (finalZones)
        finalZones.sort((a, b) => (a.name > b.name ? 1 : (a.name < b.name ? -1 : 0)));
    
    const [use24HourFormat] = useState(sessionStorage.getItem("use_24_hour_format") === "1");
    const [showTimeTillSeconds] = useState(sessionStorage.getItem("show_time_till_seconds") === "1");

    const renderTime = time => {
        const secondsFormat = showTimeTillSeconds ? ":ss" : "";
        if (use24HourFormat) return moment(time, "YYYY-MM-DD HH:mm:ss").format(`DD/MM/YYYY ${use24HourFormat ? `HH:mm${secondsFormat}` : `hh:mm${secondsFormat} a`}`);
        return moment(time, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY hh:mm:ss A")
    };
    const onParkingChange = (parking) => {
        setCurrentParking({ ...parking, allZones: true });
    };

    const onZoneChange = (event) => {
        setCurrentParking({
            ...currentParking,
            id: event.target.value,
            name: zoneLabels[zoneIds.findIndex(id => id === event.target.value)],
            allZones: event.target.value === "All"
        });
    };

    const setTimeFilters = () => {
        setStartDateTimeFilter(startDateTime);
        setEndDateTimeFilter(endDateTime);
    };
    useEffect(() => {
        let values = {}
        // Add more types based on the filters
        if (filterListValue) {
            for (let val in filterListValue) {
                if (filterListValue[val].filterType === "Action") {
                    values = { ...values, action_type: filterListValue[val].value ? filterListValue[val].value : undefined }
                }
                if (filterListValue[val].filterType === "Section") {
                    values = { ...values, section_type: filterListValue[val].value ? filterListValue[val].value : undefined }
                }
            }
            setSettingFilterFormat(values)
        }
        if (filterListValue === null) {
            setSettingFilterFormat({})
        }
    }, [filterListValue]) // eslint-disable-line react-hooks/exhaustive-deps

    React.useEffect(() => {
        eventTracker(CATEGORY, "DASHBOARD LOGS LIST")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <div className={classes.list}>

<div className={classes.parkingSelectorContainer} style={{ gridAutoFlow: isSmallDevice ? "row" : "column", gridTemplateColumns: isSmallDevice ? "100%" : "48% 48%", gridRowGap: isSmallDevice ? 18 : 0, margin: 0 }}>
            {showFilter && <ParkingSearchSelector
                value={currentParking}
                onChange={onParkingChange}
                clearable={true}
                pathName={location.pathname}
            />}

            {currentParking.zone_ids && currentParking.zone_ids.includes(',') &&
                <FormControl variant="outlined" style={{ marginTop: isSmallDevice ? 0 : 10 }}>
                    <InputLabel>Zone Name</InputLabel>
                    <Select
                        value={currentParking.allZones ? "All" : currentParking.id}
                        onChange={onZoneChange}
                        label="Zone Name"
                        variant="outlined"
                    >
                        <MenuItem value="All">All</MenuItem>
                        {finalZones.map((zone, index) => (
                            <MenuItem key={index} value={zone.id}>{zone.name}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
            }
        </div>

        <div className='customStyleForDataSearchDiv'>
            <CustomSearch search={search} setSearch={setSearch} searchTypes={searchTypes} setSearchTypes={setSearchTypes} searchTypeState={searchTypeState} pathName={location.pathname} />
            <CustomDateTimePicker startDateTime={startDateTime} setStartDateTime={setStartDateTime} endDateTime={endDateTime} setEndDateTime={setEndDateTime} onChange={setTimeFilters} />
            <CustomFilter filterTypesInitState={filterTypesInitState} filterListValue={filterListValue} setFilterListValue={setFilterListValue} pathName={location.pathname} />
        </div>
        <List
            {...props}
            style={{marginTop: 20}}
            title="Dashboard Logs"
            bulkActionButtons={false}
            exporter={false}
            filter={filter}
            empty={false}
            pagination={<CustomPagination />}
            actions={false}
        >
            {
                isSmallDevice ?
                    <SimpleList
                        primaryText={record => record.username}
                        secondaryText={record => (<div onClick={() => {
                            setDisplayModal(true)
                            setUpdatedData({ oldData: record.old_value ? record.old_value : "No Old Value", newData: JSON.parse(record.new_value) })
                        }}>
                            {record.section && <div><span style={{ color: "#5a5a5a" }}>Section: </span>{record.section}</div>}
                            {record.action && <div style={{ color: ACTIONS[record.action] }}><span style={{ color: "#5a5a5a" }}>Action: </span>{record.action}</div>}
                            {record.time && <div><span style={{ color: "#5a5a5a" }}>Timestamp: </span>{renderTime(record["time"])}</div>}
                        </div>)}
                        onContextMenu={event => event.preventDefault()}
                        linkType={false}
                        rowStyle={() => ({ alignItems: "flex-start", borderBottom: "1px solid #18cc69" })}
                    />
                    :
                    <Datagrid component={ScrollableTable} rowClick={(id, resource, record) => {
                        setDisplayModal(true)
                        setUpdatedData({ oldData: record.old_value && Array.isArray(JSON.parse(record.old_value)) ? JSON.parse(record.old_value)[0] : record.old_value && !Array.isArray(JSON.parse(record.old_value)) ? JSON.parse(record.old_value) : "No Old Value", newData: record.new_value ? JSON.parse(record.new_value) : "No New Value" })
                    }}>
                        <TextField source='display_name' label="Name" />
                        <FunctionField source='username' label="Username" render={record => record && <span style={{ fontWeight: "bold" }}>{record.username}</span>} />
                        <TextField source='section' label="Section" />
                        <FunctionField source='action' label="Action" render={record => record && <span style={{ color: ACTIONS[record.action], fontWeight: "bold" }}>{record.action}</span>} />
                        <FunctionField source="time" label="Time" render={record => renderTime(record["time"])} />
                    </Datagrid>
            }
        </List>
        <CustomModal displayModal={displayModal} setDisplayModal={setDisplayModal} updatedData={updatedData} />
    </div>
};

const CustomModal = ({ displayModal, setDisplayModal, updatedData }) => {
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    let { oldData, newData } = updatedData
    return (
        <div>
            <div className={`CustomModal ${displayModal ? "Show" : ""}`} style={{ width: displayModal ? "calc(100vw - 200px)" : "" }}>
                <IconButton
                    onClick={() => setDisplayModal(!displayModal)}
                >
                    <ArrowBackIcon />
                </IconButton>
                <div className='siteAuditsScroll' style={{ display: "grid", gap: 10, gridTemplateColumns: isSmallDevice ? "100%" : "repeat(auto-fit, minmax(200px, 500px))", justifyContent: "center", overflow: "auto", overflowX: "hidden", height: "calc(100vh - 50px)" }}>
                    {newData &&
                        <div>
                            <p style={{ fontWeight: "bold" }}>New Values</p>
                            {typeof newData === "object" ? Object.keys(newData).map(newVal => {
                                return <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 200px))", gap: 10, fontSize: 12 }}>
                                    <p style={{ fontWeight: "bold" }}>{newVal} :</p>
                                    <p style={{ wordWrap: "break-word" }}>{typeof newData[newVal] === "object" ? JSON.stringify(newData[newVal]) : newData[newVal]}</p>
                                </div>
                            }) : <p style={{ fontSize: 12 }}>{newData}</p>}
                        </div>}
                    {oldData &&
                        <div>
                            <p style={{ fontWeight: "bold" }}>Old Values</p>
                            {typeof oldData === "object" ? Object.keys(oldData).map(oldVal => {
                                return <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 200px))", gap: 10, fontSize: 12 }}>
                                    <p style={{ fontWeight: "bold" }}>{oldVal} :</p>
                                    <p style={{ wordWrap: "break-word" }}>{typeof oldData[oldVal] === "object" ? JSON.stringify(oldData[oldVal]) : oldData[oldVal]}</p>
                                </div>
                            }) : <p style={{ fontSize: 12 }}>{oldData}</p>}
                        </div>}
                </div>
            </div>
            <div
                className={`CustomOverlay ${displayModal ? "Show" : ""}`}
                onClick={() => setDisplayModal(!displayModal)}
            />
        </div>
    )
}